var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m6.343 16.242 4.243-4.243-4.243-4.243 1.414-1.414L12 10.585l4.243-4.243 1.414 1.414L13.414 12l4.243 4.243-1.414 1.414L12 13.413l-4.243 4.243-1.414-1.414Z",
    fill: "currentColor"
  })));
};
export default SvgClose;